import React, { useState } from 'react';
import styles from './StatusDeposit.module.scss';
import clsx from 'clsx';
import { Error } from '@mui/icons-material';
import { purple } from '@mui/material/colors';
const StatusDeposit = ({ status, circle, noTooltip, onClick = () => {} }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <div className={clsx(styles.wrap)} onClick={onClick}>
        {circle ? (
          <div
            className={clsx(styles.statusCircle, status == 'wait' && styles.statusCircleWait, status == 'paid' && styles.statusCirclePaid, (status == 'success' || status == 'delivered') && styles.statusCircleSuccess, (status == 'not-available' || status == 'incorrect') && styles.statusCircleError)}
            onMouseEnter={() => {
              if (!noTooltip) {
                setShow(true);
              }
            }}
            onMouseLeave={() => {
              if (!noTooltip) {
                setShow(false);
              }
            }}></div>
        ) : (
          <div
            className={clsx(
              styles.status,
              status == 'wait' && styles.statusWait,
              status == 'paid' && styles.statusPaid,
              (status == 'success' || status == 'delivered') && styles.statusSuccess,
              (status == 'not-available' || status == 'incorrect') && styles.statusError,

              status == 'return' && styles.statusReturn,
            )}
            onMouseEnter={() => {
              if (!noTooltip) {
                setShow(true);
              }
            }}
            onMouseLeave={() => {
              if (!noTooltip) {
                setShow(false);
              }
            }}>
            {' '}
            {status == 'wait' ? 'Ждет оплаты' : status == 'success' ? 'Выполнено' : status == 'delivered' ? 'Доставлен' : status == 'paid' ? 'Оплачен' : status == 'incorrect' ? 'Данные некорректны' : status == 'not-available' ? 'Пакет недоступен' : status == 'return' ? 'Возврат на DSWallet' : ''}
          </div>
        )}
        {status !== 'not-available' && status !== 'incorrect' && status !== 'return' && (
          <div className={clsx(styles.popUp, circle && styles.popUpCircle, show && styles.popUpActive)}>
            {status == 'wait' ? (
              <>
                Покупка оформлена, ожидайте <br /> оплаты
              </>
            ) : status == 'success' ? (
              <>Все заказы доставлены</>
            ) : status == 'delivered' ? (
              <>
                Заказ успешно доставлен на <br />
                указанные реквезиты
              </>
            ) : (
              <> Заказ оплачен, ожидайте донат</>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default StatusDeposit;
